import { Box } from '@mui/material';
import Table, { Column } from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { DataLoggerTableColumns } from '../helpers/DataLoggerTableColumns';
import { useDataLoggerTable } from '../hooks/useDataLoggerTable';


interface DataLoggerTableProps {
  searchString: string;
  isPending?: boolean;
  onEditClick: (id: string) => void;
}

export default function DataLoggerTable({
  searchString,
  isPending,
  onEditClick,
}: DataLoggerTableProps) {
  const {
    dataLoggers = [],
    tableContainerRef,
    lastElementRef
  } = useDataLoggerTable(searchString);
  const columns = DataLoggerTableColumns(onEditClick) as Column[];
  const hasNoData = !isPending && (!dataLoggers || dataLoggers.length === 0);

  return (
    <Box
      ref={tableContainerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: { xs: '76vh', md: '70vh' },
        opacity: isPending ? '0.3' : '1',
      }}
    >
      {hasNoData ? (
        <NoDataView message="No data available" />
      ) : (
        <Table
          stickyHeader
          rows={dataLoggers}
          columns={columns}
          lastRowRef={lastElementRef}
        />
      )}
    </Box>
  );
} 